import {modal_action} from "../actions/modal";

const inited = {
    display: false,
    code: null,
    data: null
};

export default function modalReducer(state = inited, action) {
    switch (action.type) {
        case modal_action:
            return {
                ...state,
                ...(action.hasOwnProperty('payload') ? action.payload : inited)
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/libs/redux/reducres/modal.js